module.exports = __webpack_public_path__ + "img/cg.37b2db47.png";